module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-lincoln.69258f73.png";